import { render, staticRenderFns } from "./VtCollapsableCard.vue?vue&type=template&id=2c056d5f&scoped=true&"
import script from "./VtCollapsableCard.vue?vue&type=script&lang=js&"
export * from "./VtCollapsableCard.vue?vue&type=script&lang=js&"
import style0 from "./VtCollapsableCard.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VtCollapsableCard.vue?vue&type=style&index=1&id=2c056d5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c056d5f",
  null
  
)

export default component.exports